
import React from 'react';
import { Helmet } from 'react-helmet';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminNavigation from '@/components/admin/AdminNavigation';

import SitemapGeneratorTrigger from '@/components/admin/SitemapGeneratorTrigger';
import AdminUserManager from '@/components/admin/AdminUserManager';
import { CalendarSyncManager } from '@/components/admin/CalendarSyncManager';

export default function AdminToolsPage() {
  return (
    <AdminLayout>
      <Helmet>
        <title>Admin Dashboard | Grandpal</title>
      </Helmet>
      
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Admin Dashboard</h1>
          <p className="text-muted-foreground">
            Manage your platform from this central dashboard
          </p>
        </div>
        
        
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-6">Quick Actions</h2>
          <AdminNavigation />
        </div>
        
        <div className="grid gap-8 md:grid-cols-1 lg:grid-cols-2">
          <SitemapGeneratorTrigger />
          <AdminUserManager />
        </div>
        
        <div className="mt-8">
          <h2 className="text-2xl font-semibold mb-6">Calendar Integration</h2>
          <CalendarSyncManager />
        </div>
      </div>
    </AdminLayout>
  );
}
